import ChartPDFDateFormattingStrategy from '../../../../pdf/formatters/ChartPDFDateFormattingStrategy'
import SingleDateFormattingStrategy from '../../../../parametersFormatting/SingleDateFormattingStrategy'

export default class ChartPDFSingleDateFormattingStrategy extends ChartPDFDateFormattingStrategy {
    constructor(dateFormat, dateFormatForFileName) {
        super(dateFormat, dateFormatForFileName)

        this.previewDateFormatStrategy = new SingleDateFormattingStrategy(dateFormat) // for use methods from lightbox preview header formatter
    }

    formatDateInformation(dateParameters) {
        return this.previewDateFormatStrategy.formatForDateInformation(dateParameters)
               + " "
               + this.previewDateFormatStrategy.formatSpecifyingInformation(dateParameters)
    }

    formatDateForFileName(dateParameters) {
        return this.formatFileNameDate(dateParameters.dateSelection.date)
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/formatters/ChartPDFSingleDateFormattingStrategy.js